<template>
   <div style="padding-top:15px">
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div class="sous-titre text-center">Retour sur l'offre gratuite</div>
         <div class="text-center container-mobile">
            <p>Vous venez de revenir sur l'offre gratuite mais vous avez plus de 10 ruches suivies, le maximum autorisé sur la version non-payante.</p>
            <p>Vous pouvez, soit supprimer certaines de vos ruches jusqu'à revenir à 10, soit reprendre un abonnement à BeePerf Premium.</p>
         </div>
         <div class="columns text-center" style="margin-top:25px;" v-if="!sabonner && !supprimer">
            <div class="column">
               <b-button
                  size="is-large"
                  type="is-danger"
                  icon-left="delete"
                  @click="supprimer = true"
               >Supprimer des ruches</b-button>
            </div>
            <div class="column">
               <b-button
                  size="is-large"
                  type="is-primary"
                  icon-left="crown"
                  @click="sabonner = true"
               >S'abonner à premium</b-button>
            </div>
         </div>
         <div>
            <SupprimerRuches v-if="supprimer" @reset="reset" />
            <Sabonner v-if="sabonner" @reset="reset" />
         </div>
      </div>
   </div>
</template>

<script>
   import SupprimerRuches from "./components/SupprimerRuches";
   import Sabonner from "./components/Sabonner";
   import { BeatLoader } from "@saeris/vue-spinners";

   export default {
      components: {
         SupprimerRuches,
         Sabonner,
         BeatLoader
      },
      data() {
         return {
            sabonner: false,
            supprimer: false,
            loading: true
         };
      },
      async mounted() {
         await this.$store.dispatch("getUser");
         if (this.user.ruches <= 10) {
            this.$router.push({ name: "dashboard" });
         }
         this.loading = false;
      },
      computed: {
         user() {
            return this.$store.state.user;
         }
      },
      methods: {
         reset() {
            this.sabonner = this.supprimer = false;
         },
         getIntent() {}
      }
   };
</script>

